import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';

@Component({
  selector: 'app-fuel-type-field',
  templateUrl: './fuel-type-field.component.html',
  styleUrls: ['./fuel-type-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class FuelTypeFieldComponent implements OnInit {
  @Input('twoWheeler') isTwoWheeler: boolean = false;
  @Input('required') isRequired = false;
  @Input('multiple') isMultiSelect:boolean = true;

  fuelTypes = [
    'petrol',
    'diesel',
    'cng',
    'petrol+cng',
    'electric',
    'lpg',
    'hybrid',
    'diesel+cng',
    'petrol+lpg',
  ];

  form: FormGroup;
  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl('fuel_type', new FormControl([], Validators.required));
    } else {
      this.form.addControl('fuel_type', new FormControl([]));
    }

    this.form.controls['fuel_type'].valueChanges.subscribe((val: any) => {
      if (val == null) {
        this.form.patchValue({ 'fuel_type': [] });
      }
    });
  }
  selectionChange(event:any){
    if(!this.isMultiSelect && event.isUserInput && event.source.selected){
      this.form.controls['fuel_type'].setValue([event.source.value]);
    }
  }

  ngOnDestroy(): void {
    this.form.removeControl('fuel_type');
  }

}
